const mandatoryFields = ['name', 'url'];

export const ALL_WEBHOOK_EVENT_TYPES = ['game.created', 'game.updated', 'game.deleted'];

export const ALL_DELIVERY_STATUSES = ['pending', 'success', 'failed', 'giving_up'];

export default mandatoryFields;
